import { productsMock } from './productsMock'

export const alsoBoughtAreaMock = {
  products: productsMock,
}
